const personaFiles = import.meta.glob('/src/prompts/personas/*.md', {
    eager: true,
    import: 'default',
});

const dietaryFiles = import.meta.glob('/src/prompts/dietary/*.md', {
    eager: true,
    import: 'default',
});

export function getAllMarkdownPrompts() {
  const personas: Record<string, string> = {};
  for (const path in personaFiles) {
    const key = path.split('/').pop()?.replace('.md', '') || path;
    personas[key] = personaFiles[path] as string;
  }
  const dietary: Record<string, string> = {};
  for (const path in dietaryFiles) {
    const key = path.split('/').pop()?.replace('.md', '') || path;
    dietary[key] = dietaryFiles[path] as string;
  }
  return { personas, dietary };
}